'use client'
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  gqlClient
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/deal/filters.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var Query = gql`
  query getDealFilters($lang: String, $limit: Int, $skip: Int, $where: ProductFilter) {
    productCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
      items {
        id
        category {
          title
          slug
        }
        zone {
          title
          slug
        }
        tagsCollection(limit: 50) {
          items {
            title
            slug
          }
        }
        deal {
          id
          label
        }
      }
    }
  }
`;
var getDealFilters = (_a) => __async(null, null, function* () {
  var _b = _a, { where } = _b, props = __objRest(_b, ["where"]);
  try {
    const res = yield gqlClient.request(minifyGqlQuery(Query), __spreadProps(__spreadValues({}, props), {
      where: __spreadValues(__spreadValues({}, commonWhere), where),
      lang: getContentfulSafeLocale(props.lang)
    }));
    return res;
  } catch (error) {
    throw new Exception({ error, name: "getDealFilters" });
  }
});
var useGetDealFilters = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getDealFilters", props],
    queryFn: () => getDealFilters(props)
  }, options));
};

export {
  useGetDealFilters
};
//# sourceMappingURL=chunk-PTSXFYKW.mjs.map